import { z } from 'zod';

export const formFieldTypeSchema = z.enum(['text', 'email', 'textarea']);

export type FormFieldType = z.infer<typeof formFieldTypeSchema>;

export const formFieldSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  type: formFieldTypeSchema,
  required: z.boolean(),
  placeholder: z.string().optional().or(z.literal('')),
});

export type FormField = z.infer<typeof formFieldSchema>;

export const formSettingsDocumentSchema = z.object({
  enabled: z.boolean(),
  destinationEmail: z.string().email().optional().or(z.literal('')),
  successMessage: z.string().min(1),
  privacyPolicyUrl: z.string().url().optional().or(z.literal('')),
  rateLimitSeconds: z.number().int().min(10).max(3600).default(30),
  retentionDays: z.number().int().min(1).max(3650).default(90),
  fields: z.array(formFieldSchema).min(1),
});

export type FormSettingsDocument = z.infer<typeof formSettingsDocumentSchema>;

export const formSettingsSchema = z.object({
  site_id: z.string(),
  settings: formSettingsDocumentSchema,
  updated_at: z.string().optional(),
});

export type FormSettings = z.infer<typeof formSettingsSchema>;

export const updateFormSettingsInputSchema = formSettingsDocumentSchema;

export type UpdateFormSettingsInput = z.infer<typeof updateFormSettingsInputSchema>;

export const formSubmissionSchema = z.object({
  id: z.string(),
  site_id: z.string(),
  payload: z.record(z.string(), z.unknown()),
  source_ip: z.string().optional().or(z.literal('')),
  user_agent: z.string().optional().or(z.literal('')),
  notification_status: z.enum(['pending', 'sent', 'skipped', 'failed']).optional().default('pending'),
  notification_error: z.string().optional().or(z.literal('')),
  notified_at: z.string().optional().nullable(),
  created_at: z.string(),
});

export type FormSubmission = z.infer<typeof formSubmissionSchema>;
